module.exports = __webpack_public_path__ + "static/media/head-vr.c9cf8512.svg";